// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonShareDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2C12 3.10457 11.1046 4 10 4C9.36263 4 8.79489 3.70185 8.42865 3.23742L3.97964 5.71357C3.99306 5.80711 4 5.90275 4 6C4 6.10808 3.99143 6.21415 3.97493 6.31758L8.41034 8.78617C8.77581 8.30827 9.3519 8 10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 9.90275 8.00694 9.80711 8.02036 9.71357L3.57135 7.23742C3.20511 7.70185 2.63737 8 2 8C0.895431 8 0 7.10457 0 6C0 4.89543 0.895431 4 2 4C2.6481 4 3.22419 4.30827 3.58966 4.78617L8.02507 2.31758C8.00857 2.21415 8 2.10808 8 2C8 0.895431 8.89543 0 10 0C11.1046 0 12 0.895431 12 2Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 3C16 4.65685 14.6569 6 13 6C12.1201 6 11.3287 5.62122 10.78 5.01783L5.92792 7.34335C5.97511 7.55469 6 7.77444 6 8C6 8.19031 5.98228 8.37648 5.9484 8.55695L10.8384 10.9197C11.3842 10.3528 12.1509 10 13 10C14.6569 10 16 11.3431 16 13C16 14.6569 14.6569 16 13 16C11.3431 16 10 14.6569 10 13C10 12.9128 10.0037 12.8265 10.011 12.7412L4.93809 10.29C4.4153 10.7329 3.73884 11 3 11C1.34315 11 0 9.65685 0 8C0 6.34315 1.34315 5 3 5C3.69943 5 4.34296 5.23936 4.85314 5.64062L10.0048 3.1715C10.0016 3.11474 10 3.05756 10 3C10 1.34315 11.3431 0 13 0C14.6569 0 16 1.34315 16 3Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21 6C21 7.65685 19.6569 9 18 9C17.1114 9 16.313 8.61363 15.7636 7.99971L8.96298 11.5274C8.98735 11.6813 9 11.8392 9 12C9 12.1521 8.98868 12.3016 8.96682 12.4477L15.9583 15.8019C16.4938 15.3043 17.2114 15 18 15C19.6569 15 21 16.3431 21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 17.8556 15.0102 17.7137 15.0299 17.5747L8.02456 14.2139C7.49095 14.7021 6.78026 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C6.77174 9 7.47542 9.2914 8.00701 9.77018L15.0033 6.14107C15.0011 6.09432 15 6.04729 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonShareDefault is a generated icon component.
 */
let IconCommonShareDefault = IconCommonShareDefault_1 = class IconCommonShareDefault extends IconBaseElement {
    render() {
        return html `${IconCommonShareDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonShareDefault.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonShareDefault = IconCommonShareDefault_1 = __decorate([
    customElement('zui-icon-common-share-default')
], IconCommonShareDefault);
export { IconCommonShareDefault };
